import { PlanTier } from '../graphql/generated/graphql';
import { VersionHistoryDays } from '../organization/PricingConfig';

type Features = Required<Window['__slab']>['FEATURES'];
export type Feature = keyof Features;

const DEFAULT_VALUES: Required<Features> = {
  ai_ask: false,
  ai_predict: false,
  api: false,
  attachment_size_limit: 25,
  button_blot: false,
  custom_domain: false,
  detached_topics: false,
  devtools: false,
  editor_iframe: false,
  guests_per_seat: 3,
  microsoft: false,
  okta: false,
  onelogin: false,
  public_posts_topics: false,
  topic_sort: false,
  version_history: VersionHistoryDays[PlanTier.Startup],
  webhook: false,
  zendesk: false,
  home_activity_v2: false,
  notifications_v2: false,
};

export function isFeatureEnabled(key: Feature) {
  if (!Object.keys(DEFAULT_VALUES).includes(key)) return false;
  return getFeature(key) !== false;
}

export default function getFeature<T extends Feature>(key: T) {
  return window?.__slab?.FEATURES?.[key] ?? DEFAULT_VALUES[key];
}
